import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api, { getApiErrorMessage } from '../../services/api';
import {
    COMPETITOR_DNI_PARAM,
    getCompetitorDniFromSearch,
    hasInvalidCompetitorParam,
} from '../../utils/competitor';

export default function EventSelection() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const competitorDni = getCompetitorDniFromSearch(searchParams);
    const invalidCompetitorParam = hasInvalidCompetitorParam(searchParams);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await api.get('/events');
                setEvents(response.data);
            } catch (err) {
                console.error("Error fetching events", err);
                setError(getApiErrorMessage(err, 'No se pudieron cargar los eventos.'));
            } finally {
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    const handleSelectEvent = (eventId) => {
        localStorage.setItem('selectedEventId', eventId);
        const params = new URLSearchParams();
        if (competitorDni) {
            params.set(COMPETITOR_DNI_PARAM, competitorDni);
        }
        const query = params.toString();
        navigate(`/sales/details${query ? `?${query}` : ''}`);
    };

    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <h2 className="text-3xl font-bold text-gray-800 text-center">Selecciona un evento</h2>

            {competitorDni && (
                <div className="p-4 bg-indigo-50 border border-indigo-100 text-indigo-700 rounded-lg shadow-sm text-sm text-center">
                    Estas comprando con el DNI de competidor <span className="font-bold">{competitorDni}</span>.
                </div>
            )}

            {invalidCompetitorParam && !competitorDni && (
                <div className="p-4 bg-amber-50 border border-amber-100 text-amber-700 rounded-lg shadow-sm text-sm text-center">
                    El link no contiene un DNI de competidor valido (7-10 digitos). Podes continuar con la compra normalmente.
                </div>
            )}

            {error && <div className="p-4 bg-red-100 text-red-700 rounded-lg shadow-sm">{error}</div>}

            {loading ? (
                <div className="text-center py-10 text-gray-500 font-medium animate-pulse">Cargando eventos...</div>
            ) : (
                <div className="flex justify-center content-center gap-6 flex-wrap">
                    {events.map(event => (
                        <div key={event.id} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border border-gray-100 flex flex-col justify-between group px-10 max-w-sm w-full">
                            <div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors">{event.title}</h3>
                                <p className="text-gray-500 text-sm mb-1 flex items-center gap-1.5">
                                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    <span>{new Date(event.date).toISOString().split('T')[0]}</span>
                                </p>
                                <p className="text-gray-500 text-sm mb-2 flex items-center gap-1.5">
                                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    <span>{event.location || 'TBA'}</span>
                                </p>
                            </div>
                            <button
                                onClick={() => handleSelectEvent(event.id)}
                                className="w-full bg-indigo-600 text-white font-bold py-2 rounded shadow hover:bg-indigo-700 transition-colors p-4"
                            >
                                Seleccionar evento
                            </button>
                        </div>
                    ))}
                    {events.length === 0 && (
                        <div className="col-span-full text-center py-10 text-gray-500 italic">
                            No se encontraron eventos
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
